import { useTranslation } from 'react-i18next';
import { ChevronRight, Plus } from 'lucide-react';

export default function MockupConfigurator() {
  const { t } = useTranslation();
  const difficultyLabels = [
    t('landing.mockupVeryEasy'),
    t('landing.mockupEasy'),
    t('landing.mockupMedium'),
    t('landing.mockupHard'),
    t('landing.mockupExpert'),
  ];

  return (
    <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
      <div className="space-y-2.5">
        <div className="rounded-xl border border-border bg-card p-3">
          <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupSimName')}</p>
          <div className="rounded-lg border border-border bg-card px-2.5 py-1.5 text-[10px] text-foreground">
            {t('landing.mockupSimName')}
          </div>
        </div>

        <div className="rounded-xl border border-border bg-card p-3">
          <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupSimType')}</p>
          <div className="flex items-center justify-between rounded-lg border border-border bg-card px-2.5 py-1.5 text-[10px] text-foreground">
            <span>{t('landing.mockupVoice')}</span>
            <ChevronRight className="h-2.5 w-2.5 rotate-90 text-muted-foreground" />
          </div>
        </div>

        <div className="rounded-xl border border-border bg-card p-3">
          <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupSalePhase')}</p>
          <div className="flex items-center justify-between rounded-lg border border-border bg-card px-2.5 py-1.5 text-[10px] text-foreground">
            <span>{t('landing.mockupCloseNeg')}</span>
            <ChevronRight className="h-2.5 w-2.5 rotate-90 text-muted-foreground" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-xl border border-border bg-card p-3">
            <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupSector')}</p>
            <div className="flex items-center justify-between rounded-lg border border-border bg-card px-2.5 py-1.5 text-[10px] text-foreground">
              <span>{t('landing.mockupTech')}</span>
              <ChevronRight className="h-2.5 w-2.5 rotate-90 text-muted-foreground" />
            </div>
          </div>
          <div className="rounded-xl border border-border bg-card p-3">
            <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupSubSector')}</p>
            <div className="flex items-center justify-between rounded-lg border border-border bg-card px-2.5 py-1.5 text-[10px] text-foreground">
              <span>SaaS B2B</span>
              <ChevronRight className="h-2.5 w-2.5 rotate-90 text-muted-foreground" />
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-border bg-card p-3">
          <p className="mb-1.5 text-[10px] font-semibold text-foreground">{t('landing.mockupDifficultyLabel')}</p>
          <div className="flex gap-1">
            {difficultyLabels.map((label, i) => (
              <button
                key={label}
                className={`flex flex-1 flex-col items-center gap-0.5 rounded-lg border px-1 py-1.5 transition-colors ${
                  i === 2
                    ? 'border-primary bg-primary/10 text-primary'
                    : 'border-border text-muted-foreground'
                }`}
              >
                <span className="text-xs font-bold">{i + 1}</span>
                <span className="text-[7px] leading-tight">{label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-1">
          <span className="text-[10px] text-muted-foreground">{t('landing.mockupClearFields')}</span>
          <button className="flex items-center gap-1.5 rounded-lg bg-primary px-3 py-1.5 text-[10px] font-semibold text-white">
            <Plus className="h-3 w-3" />
            {t('landing.mockupCreateSim')}
          </button>
        </div>
      </div>
    </div>
  );
}
